import { Navigate, useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { userContext } from '../UserContext';
import Screenloader from '../components/screenLoader/Screenloader';

export type Role = 'admin' | 'hr' | 'employee';

type Props = {
  children: React.ReactNode;
  allowedRoles?: Role[];
};

const normalizeRole = (role: unknown): Role | null => {
  if (typeof role !== 'string') return null;

  switch (role.toLowerCase()) {
    case 'admin':
      return 'admin';
    case 'hr':
      return 'hr';
    case 'employee':
      return 'employee';
    default:
      return null;
  }
};

const ProtectedRoute = ({ children, allowedRoles }: Props) => {
  const { user, loading } = useContext(userContext);
  const location = useLocation();

  if (loading) return <Screenloader />; // show loader while checking user

  if (!user?._id) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    const role = normalizeRole(user.role);
    if (!role || !allowedRoles.includes(role)) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
